
<template>
    <div id="socket"> </div>
</template>

<script>
  import {mapState,mapMutations} from 'vuex';
  import mqtt from "mqtt";
  import localStorage from '../../libs/js/localStorage.js'
  import dataUrl from '../../libs/js/interfaceAddress.js';  //接口
  import {getUkeyObject,checkError,getError} from '../login/Ukey/mToken_System.js';   //验证ukey的方法
//   import {ExportLibrary, LibraryFactory} from '../../libs/js/paho-mqtt'
  export default {
    props: {
        info: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
      return {
        // options: {},
        // client:{},
        message:null,
        userInfo:{},
        userTopic:[],
        //2019-5-29修改
        userData:{},
        client:null,
      }
    },
    mounted () {
        // this.$nextTick(()=>{
        //     this.getSocketLink();
        // })
        this.$bus.$on('closeMqtt',this.closeMqtt);


    },
    computed:{
        ...mapState(['clients']),
    },
    beforeDestroy(){
         this.$bus.$off('closeMqtt',this.closeMqtt);
    },
    watch:{
        info:{
            handler(newVal,oldVal){
                this.userInfo = newVal;
                this.userTopic = this.userInfo.topic;
                // var clients = localStorage.getStore('clientData');
                // var str = clients.serialno;
                // str+=clients.username;
                // this.userData = {
                //     clientId:clients.serialno,
                //     user:clients.username,
                //     pwd:this.$md5(str)
                // }
                this.getSocketLink();
                // this.init();
            },
            deep:true
        }
    },
    methods: {
      ...mapMutations(['set_message']),
        closeMqtt(){
            if(this.client){
                this.client.end();
            }
        },
         //刷新token
      get_ukey(){
        //检测u盾是否存在
        var clients = localStorage.getStore('clientData');
        console.log( '获取refresh_token-=-=-get_ukey=-=--='+clients.safetycode);
        let ukey = getUkeyObject(clients.safetycode);
        if(ukey_code.num === 1003){ //证明检测到ukey未插入
            localStorage.removeStore('info');
            localStorage.removeStore('loginStatus')
               this.$router.replace({
                path: "/login"
            });
            this.closeMqtt();
        }
      },
        
        /**
         * 大屏连接mqtt
         * clinetId：ukey序列号
         * username：监控账号（例：ztjw_ld）
         * password：MD5(clinetId+username)
         * */
        getSocketLink() {
            // WebSocket 连接字符串

            // const WebSocket_URL = "wss://emq.bjgas95.com:8084/mqtt";  //测试
            const WebSocket_URL = process.env.VUE_EMQ_API;;  //正式

          // const WebSocket_URL = "ws://172.16.8.183:8083/mqtt";  //山西正式

            var clients = localStorage.getStore('clientData');
            // var str = clients.serialno.split(":")[0];
            // str+=clients.username;
            // 连接选项
            const options = {
                // 超时时间
                // connectTimeout: 30000,
                // 认证信息
                /*
                * 测试
                // username: "test",
                // password: "test_123456  ,

                // clientId: this.userInfo.clientId||'',
                // username: this.userInfo.user || '',
                // password :this.userInfo.pwd || '',
                /*
                  * 正式
                  * */
                // clientId: clients.serialno.split(":")[0]||'',
                // username: clients.username || '',
                // password: this.$md5(str) || '',

                clientId: 'monitor_'+clients.username,
                username: clients.username,
                password: this.$md5('monitor_'+clients.username),

                // 心跳时间
                keepalive: 60,
                clean: true,
                reconnectPeriod:2000

            };

            // console.log('定月失败数据clientid'+JSON.stringify(options))

            // const client = mqtt.connect(WebSocket_URL, options);
            this.client = mqtt.connect(WebSocket_URL, options);
            // 连接成功后初始化订阅
            this.client.on("connect", () => {
                console.log("Connected to", WebSocket_URL);
                // 订阅主题
                for ( var i = 0; i <this.userTopic.length; i++){
                // client.subscribe(that.userTopic[i]);
                    this.client.subscribe(this.userTopic[i], err => {
                        console.log(err || "订阅成功");
                    });
                }
            });
            // 为 message 时间添加处理函数
            this.client.on("message", (topic, message) => {
                this.set_message(message.toString());
                console.log("收到来自", topic, "的消息:", message.toString());
            });
            var n =0;
            this.client.on("offline", () => {

                console.log("offline");
                this.$message.error('订阅失败');
                n++;
                // console.log(n,'订阅失败次数')
                if(n>=20){   //订阅失败次数达20次就检测U盾是否存在
                    this.get_ukey();
                    n=0;
                }
            });
            this.client.on("error", error => {
                console.log("error is", error.toString);
            });

            this.client.on("end", () => {
                console.log("end");
            });
        // client.on("reconnect", () => {
        //   console.log("reconnect");

        // });

        // 发布消息
        // client.publish("hello", "Hello EMQ X", err => {
        //   console.log(err || "发布成功");
        // });
    }

    ///本地引入js执行
    // let client = new LibraryFactory
    // var clientId = '';
    // if(JSON.stringify(this.userInfo) !== '{}'){
    //     clientId = this.userInfo.clientId;
    // }
    // client.Client('39.105.86.39', Number(8083), clientId)
    // //注册连接断开处理事件
    // client.onConnectionLost = onConnectionLost;
    // //注册消息接收处理事件
    // client.onMessageArrived = this.onMessageArrived;

    // client.onConnected = onConnected;
    // var options = {
    //     onSuccess: onConnect,
    //     userName: this.userInfo.user || '',
    //     password :this.userInfo.pwd || '',
    //     useSSL: false,
    //     reconnect: true,
    //     timeout: 5,
    // }
    // client.connect(options)

    // let that = this

    // function onConnect () {
    //     console.log('onConnect' + '连接成功')
    //     // client.subscribe("/msg/1/#");
    //    for ( var i = 0; i <that.userTopic.length; i++){
    //         client.subscribe(that.userTopic[i]);
    //     }

    // }
    // //当客户端失去连接时调用
    // function onConnectionLost(responseObject) {
    //     console.log('onConnectionLost')
    // }
    // function onConnected (reconnect, uri) {
    //     console.log('连接成功123456')
    //     // client.subscribe("/msg/1/#");
    //     for ( var i = 0; i <that.userTopic.length; i++){
    //         client.subscribe(that.userTopic[i]);
    //     }
    // }
    // },
    // onMessageArrived(message){
    //      this.set_message(message.payloadString);
    // }


    //线上引入js执行
    //   getSocketLink () {
    //     var options = {
    //         onSuccess: onConnect,
    //         // userName : 'webClient2',
    //         // password : 'webClient2',
    //         userName: this.userInfo.user || '',
    //         password :this.userInfo.pwd || '',
    //         useSSL: false,
    //         // timeout: 5,
    //         // keepAliveInterval: 50,  //保持间隔
    //         // cleanSession: false, //清除会话
    //     };
    //     var clientId = '';
    //     if(JSON.stringify(this.userInfo) !== '{}'){
    //         clientId = this.userInfo.clientId;
    //     }
    //     var client = new Paho.MQTT.Client("39.105.86.39", Number(8083),clientId); //设置回调处理程序

    //     //注册连接断开处理事件
    //     client.onConnectionLost = onConnectionLost;

    //     //注册消息接收处理事件
    //     client.onMessageArrived = this.onMessageArrived;
    //     client.onConnected = onConnected;

    //     //连接客户端
    //     client.connect(options);  //连接服务器并注册连接成功处理事件
    //     // 当客户端连接时调用
    //     let that = this;
    //     function onConnect() {
    //         //建立连接后，进行订阅并发送消息。
    //         console.log("onConnect" + "连接成功");
    //         //   client.subscribe("/msg/1/#");

    //         for ( var i = 0; i <that.userTopic.length; i++){
    //             client.subscribe(that.userTopic[i]);
    //         }

    //       // message = new Paho.MQTT.Message("Hello");
    //       // message.destinationName = "World";
    //       // client.send(message);
    //     }
    //     function onConnected(reconnect, uri) {
    //       console.log('连接成功')
    //     //    client.subscribe("/msg/222");
    //        for ( var i = 0; i <that.userTopic.length; i++){
    //             client.subscribe(that.userTopic[i]);
    //         }
    //       // Once a connection has been made, make a subscription and send a message.
    //       // logMessage("INFO", "Client Has now connected: [Reconnected: ", reconnect, ", URI: ", uri, "]");
    //       // connected = true;


    //     }
    //     //用户连接失败
    //     function onFail(context) {
    //       logMessage("连接失败", "Failed to connect. [Error Message: ", context.errorMessage, "]");
    //     }

    //     //当客户端失去连接时调用
    //     function onConnectionLost(responseObject) {
    //          console.log('onConnectionLost')
    //       if (responseObject.errorCode !== 0) {
    //         // console.log("onConnectionLost:"+responseObject.errorMessage +'连接已断开');
    //       }
    //     }

    //     //当消息到达时呼叫
    //     // function onMessageArrived(message) {
    //     //   console.log("onMessageArrived:"+message.payloadString +'收到消息');
    //     //   var message = message.payloadString;
    //     // }
    //   },
    //   //当消息到达时呼叫
    //   onMessageArrived(message){
    //        this.set_message(message.payloadString);
    //   }

    }
  }
</script>







// WEBPACK FOOTER //
// src/page/main_content/mqttws.vue